export default class ItemCliente {

    CodigoCliente: string;
    RazonSocial: string;
    Nombre: string;
    PersonaContacto: string;
    Email:string;
    URL: string;
    NIF: string;
    TerminalesContratados: number;
    ClaveActivacion: string;
    Exportacion: string;
    P1: string;
    P2: string;
    APIKEY: string;
    Bloqueado: string;
    UrlLogo: string;
    fecAlta: Date;
    FecMod: Date;
    datetime: Date;
    usrAlta: string;
    usrMod: string;
    Espacio: string;
    Prefijo: string;
    Telefono: string;

    constructor() {
        this.CodigoCliente = "";
        this.RazonSocial = "";
        this.Nombre = "";
        this.PersonaContacto = "";
        this.Email = "";
        this.URL = "";
        this.NIF = "";
        this.TerminalesContratados = 0;
        this.ClaveActivacion = "";
        this.Exportacion = "";
        this.P1 = "";
        this.P2 = "";
        this.APIKEY = "";
        this.Bloqueado = "";
        this.UrlLogo = "";
        this.fecAlta = new Date();
        this.FecMod = new Date();
        this.datetime = new Date();
        this.usrAlta = "";
        this.usrMod = "";
        this.Espacio = "";
        this.Prefijo = "";
        this.Telefono = "";
    };
};
